
import { RevLink } from '@ds/components/Link'

import translations from './ToggleText.translations'

export default {
  components: {
    RevLink,
  },
  data() {
    return {
      isVisible: false,
    }
  },
  computed: {
    label() {
      return this.isVisible ? translations.hide : translations.show
    },
  },
  methods: {
    toggleDisplay() {
      this.isVisible = !this.isVisible
    },
  },
}
